const Api = {
    '/api/order/order-search-belong' : 1, // 修改订单归属/批量修改订单归属
    '/api/order/order-batch-belong': 1, // 批量修改订单归属
}

export default{
    Api
}